import { Component, OnInit, Injector } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { Ticket } from '../../models/RestModels';
import { SearchObject } from '../../services/Rest';
import { filter, mergeMap } from 'rxjs/operators';
import { ConfirmationResult } from 'src/app/services/confirmation.service';

@Component({
	selector: 'app-list-ticket-config',
	templateUrl: './list-ticket-config.component.html',
	styleUrls: ['./list-ticket-config.component.css']
})
export class ListTicketConfigComponent extends BaseComponent implements OnInit {

	ticket_list: Ticket[] = [];

	constructor(public injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.setTitle('Configuraciones de Ticket');
		this.loadTickets();
	}

	loadTickets() {
		this.is_loading = true;

		this.subs.sink = this.rest.ticket.search({
			limit: 9999,
			sort_order: ['name_ASC']
		}).subscribe(
			(response) => {
				this.is_loading = false;
				this.ticket_list = response.data;
			},
			(error) => {
				this.is_loading = false;
				this.showError('Error al cargar tickets');
			}
		);
	}

	deleteTicket(ticket: Ticket) {

		this.sink = this.confirmation.showConfirmAlert
		(
			ticket,
			'Confirmar eliminacion',
			'Eliminar configuracion "' + ticket.name + '"?'
		)
		.pipe
		(
			filter((response:ConfirmationResult)=>response.accepted),
			mergeMap(()=>this.rest.ticket.delete(ticket))
		)
		.subscribe((obj:any) =>
		{
			this.showSuccess('Configuracion eliminada');
			this.loadTickets();
		}, (error) =>
		{
			this.is_loading = false;
			this.showError('Error al eliminar');
		});
	}
}
